import React from 'react';
import './AdminPreviewBar.css';

interface AdminPreviewBarProps {
  onExit: () => void;
}

/**
 * Slim banner shown ONLY when the admin is previewing the fan-facing app.
 * Real fans never see this — it renders above the regular header and is
 * keyed off `currentUser.isAdmin && !isAdminView` in App.tsx.
 */
const AdminPreviewBar: React.FC<AdminPreviewBarProps> = ({ onExit }) => {
  return (
    <div className="admin-preview-bar" role="region" aria-label="Admin preview">
      <div className="admin-preview-bar-inner">
        <span className="apb-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </span>
        <span className="apb-label">
          <strong>Preview mode</strong>
          <span className="apb-sub">You're viewing the app as a subscriber</span>
        </span>
        <button className="apb-exit" onClick={onExit}>
          Exit preview
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M5 12h14M13 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AdminPreviewBar;
